const TRAVEL_COST = [
	{city: '仲恺',location: '惠环镇',place: '惠环',mileage: '11',cost: '36'},{city: '仲恺',location: '惠环镇',place: '平南',mileage: '11',cost: '36'},
	{city: '仲恺',location: '沥林镇',place: '沥林',mileage: '24',cost: '77'}, {city: '仲恺',location: '陈江镇',place: '陈江',mileage: '20',cost: '64'},
	{city: '仲恺',location: '潼侨镇',place: '潼侨',mileage: '30',cost: '64'}, {city: '仲恺',location: '潼桥镇',place: '潼桥',mileage: '30',cost: '64'},
	{city: '仲恺',location: '潼湖镇',place: '潼湖',mileage: '20',cost: '95'}, 
	{city: '仲恺',location: '陈江镇',place: '东江',mileage: '24',cost: '64'},

	{city: '惠阳区',location: '平潭镇',place: '平潭',mileage: '20',cost: '64'}, {city: '惠阳区',location: '良井镇',place: '良井',mileage: '25',cost: '80'},
	{city: '惠阳区',location: '镇隆镇',place: '镇隆',mileage: '21',cost: '67'}, {city: '惠阳区',location: '永湖镇',place: '永湖',mileage: '24',cost: '77'},
	{city: '惠阳区',location: '新圩镇',place: '新圩',mileage: '30',cost: '96'}, {city: '惠阳区',location: '沙田镇',place: '沙田',mileage: '45',cost: '144'},
	{city: '惠阳区',location: '秋长镇',place: '秋长',mileage: '39',cost: '125'}, {city: '惠阳区',location: '三和',place: '三和',mileage: '30',cost: '96'},
	{city: '惠阳区',location: '澳头镇',place: '澳头',mileage: '52',cost: '166'}, {city: '惠阳区',location: '霞涌镇',place: '霞涌',mileage: '90',cost: '287'},
	{city: '惠阳区',location: '淡水',place: '淡水',mileage: '39',cost: '125'}, {city: '惠阳区',location: '太阳城',place: '太阳城',mileage: '30',cost: '96'},

	{city: '惠东县',location: '平山镇',place: '平山',mileage: '38',cost: '122'}, {city: '惠东县',location: '平海镇',place: '平海',mileage: '82',cost: '262'},
	{city: '惠东县',location: '大岭镇',place: '大岭',mileage: '36',cost: '115'}, {city: '惠东县',location: '多祝镇',place: '多祝',mileage: '60',cost: '192'},
	{city: '惠东县',location: '稔山镇',place: '稔山',mileage: '60',cost: '192'}, {city: '惠东县',location: '梁化镇',place: '梁化',mileage: '36',cost: '115'},
	{city: '惠东县',location: '吉隆镇',place: '吉隆',mileage: '77',cost: '246'}, {city: '惠东县',location: '焦田',place: '焦田',mileage: '36',cost: '115'},
	{city: '惠东县',location: '黄埠镇',place: '黄埠',mileage: '90',cost: '288'}, {city: '惠东县',location: '白花',place: '白花',mileage: '36',cost: '115'},
	{city: '惠东县',location: '白盆珠镇',place: '白盆珠',mileage: '78',cost: '250'}, {city: '惠东县',location: '高潭镇',place: '高潭',mileage: '176',cost: '564'},
	{city: '惠东县',location: '安墩镇',place: '安墩',mileage: '91',cost: '290'}, {city: '惠东县',location: '宝口镇',place: '宝口',mileage: '117',cost: '373'},
	{city: '惠东县',location: '盐洲',place: '盐洲',mileage: '110',cost: '352'}, {city: '惠东县',location: '铁涌镇',place: '铁涌',mileage: '84',cost: '267'},
	{city: '惠东县',location: '港口',place: '港口',mileage: '82',cost: '262'},{city: '惠东县',location: '巽寮',place: '巽寮',mileage: '60',cost: '192'},

	{city: '龙门县',location: '南昆山',place: '南昆山',mileage: '130',cost: '419'},

	{city: '龙门县',location: '龙城',place: '龙城',mileage: '97',cost: '310'}, {city: '龙门县',location: '平陵镇',place: '平陵',mileage: '84',cost: '269'},
	{city: '龙门县',location: '永汉镇',place: '永汉',mileage: '131',cost: '419'}, {city: '龙门县',location: '地派镇',place: '地派',mileage: '137',cost: '438'},
	{city: '龙门县',location: '蓝田乡',place: '蓝田',mileage: '136',cost: '435'}, {city: '龙门县',location: '麻榨镇',place: '麻榨',mileage: '134',cost: '429'},
	{city: '龙门县',location: '龙华镇',place: '龙华',mileage: '99',cost: '317'}, {city: '龙门县',location: '龙江镇',place: '龙江',mileage: '90',cost: '287'},
	{city: '龙门县',location: '龙潭镇',place: '龙潭',mileage: '136',cost: '436'}, {city: '龙门县',location: '龙田镇',place: '龙田',mileage: '120',cost: '385'},
	{city: '龙门县',location: '王坪',place: '王坪',mileage: '82',cost: '262'},

	{city: '博罗',location: '罗阳',place: '罗阳',mileage: '31',cost: '99'}, {city: '博罗',location: '义和',place: '义和',mileage: '38',cost: '122'},
	{city: '博罗',location: '龙溪镇',place: '龙溪',mileage: '41',cost: '131'}, {city: '博罗',location: '园洲镇',place: '园洲',mileage: '70',cost: '224'},
	{city: '博罗',location: '福田镇',place: '福田',mileage: '58',cost: '186'}, {city: '博罗',location: '石湾镇',place: '石湾',mileage: '80',cost: '256'},
	{city: '博罗',location: '横河镇',place: '横河',mileage: '46',cost: '148'}, {city: '博罗',location: '长宁镇',place: '长宁',mileage: '63',cost: '202'},
	{city: '博罗',location: '龙华镇',place: '龙华',mileage: '52',cost: '166'}, {city: '博罗',location: '柏塘镇',place: '柏塘',mileage: '50',cost: '160'},
	{city: '博罗',location: '响水河镇',place: '响水河',mileage: '50',cost: '160'}, {city: '博罗',location: '平安镇',place: '平安',mileage: '70',cost: '224'},
	{city: '博罗',location: '湖镇镇',place: '湖镇',mileage: '40',cost: '128'}, {city: '博罗',location: '观音阁',place: '观音',mileage: '65',cost: '208'},
	{city: '博罗',location: '杨侨镇',place: '杨侨',mileage: '46',cost: '148'}, {city: '博罗',location: '石坝镇',place: '石坝',mileage: '67',cost: '214'},
	{city: '博罗',location: '麻陂镇',place: '麻陂',mileage: '60',cost: '192'}, {city: '博罗',location: '杨村镇',place: '杨村',mileage: '50',cost: '160'},
	{city: '博罗',location: '泰美镇',place: '泰美',mileage: '33',cost: '106'}, {city: '博罗',location: '公庄镇',place: '公庄',mileage: '68',cost: '218'},
	
	{city: '其他',location: '深圳',place: '深圳',mileage: '79',cost: '253'},	{city: '其他',location: '广州',place: '广州',mileage: '159',cost: '509'},
]

const TRAVEL_COST_NEW = {
	'惠城': [{location: '惠城',place: '惠城',cost: '0'}],
	'大亚湾': [{location: '大亚湾',place: '大亚湾',cost: '0'}],
	'仲恺': [
		{location: '惠环镇',place: '惠环',cost: '36'}, {location: '惠环镇',place: '平南',cost: '36'}, {location: '沥林镇',place: '沥林',cost: '77'}, 
		{location: '陈江镇',place: '陈江',cost: '64'}, {location: '潼侨镇',place: '潼侨',cost: '64'}, {location: '潼桥镇',place: '潼桥',cost: '64'},
		{location: '潼湖镇',place: '潼湖',cost: '95'}, {location: '陈江镇',place: '东江',cost: '64'},
	],
	'惠阳': [
		{location: '平潭镇',place: '平潭',cost: '64'}, {location: '良井镇',place: '良井',cost: '80'}, {location: '镇隆镇',place: '镇隆',cost: '67'}, 
		{location: '永湖镇',place: '永湖',cost: '77'}, {location: '新圩镇',place: '新圩',cost: '96'}, {location: '沙田镇',place: '沙田',cost: '144'},
		{location: '秋长镇',place: '秋长',cost: '125'}, {location: '三和',place: '三和',cost: '96'}, {location: '澳头镇',place: '澳头',cost: '166'}, 
		{location: '霞涌镇',place: '霞涌',cost: '287'}, {location: '淡水镇',place: '淡水',cost: '125'}, {location: '太阳城',place: '太阳城',cost: '96'},
	],
	'惠东': [
		{location: '平山镇',place: '平山',cost: '122'}, {location: '平海镇',place: '平海',cost: '262'},
		{location: '大岭镇',place: '大岭',cost: '115'}, {location: '多祝镇',place: '多祝',cost: '192'},
		{location: '稔山镇',place: '稔山',cost: '192'}, {location: '梁化镇',place: '梁化',cost: '115'},
		{location: '吉隆镇',place: '吉隆',cost: '246'}, {location: '焦田',place: '焦田',cost: '115'},
		{location: '黄埠镇',place: '黄埠',cost: '288'}, {location: '白花',place: '白花',cost: '115'},
		{location: '白盆珠镇',place: '白盆珠',cost: '250'}, {location: '高潭镇',place: '高潭',cost: '564'},
		{location: '安墩镇',place: '安墩',cost: '290'}, {location: '宝口镇',place: '宝口',cost: '373'},
		{location: '盐洲',place: '盐洲',cost: '352'}, {location: '铁涌镇',place: '铁涌',cost: '267'},
		{location: '港口',place: '港口',cost: '262'},{location: '巽寮',place: '巽寮',cost: '192'},
	],
	'龙门': [
		{location: '南昆山',place: '南昆山',cost: '419'}, {location: '龙城',place: '龙城',cost: '310'}, {location: '平陵镇',place: '平陵',cost: '269'},
		{location: '永汉镇',place: '永汉',cost: '419'}, {location: '地派镇',place: '地派',cost: '438'}, {location: '蓝田乡',place: '蓝田',cost: '435'},
		{location: '麻榨镇',place: '麻榨',cost: '429'}, {location: '龙华镇',place: '龙华',cost: '317'}, {location: '龙江镇',place: '龙江',cost: '287'},
		{location: '龙潭镇',place: '龙潭',cost: '436'}, {location: '龙田镇',place: '龙田',cost: '385'}, {location: '王坪',place: '王坪',cost: '262'},
	],
	'博罗': [
		{location: '罗阳',place: '罗阳',cost: '99'}, {location: '义和',place: '义和',cost: '122'}, {location: '龙溪镇',place: '龙溪',cost: '131'}, 
		{location: '园洲镇',place: '园洲',cost: '224'}, {location: '福田镇',place: '福田',cost: '186'}, {location: '石湾镇',place: '石湾',cost: '256'},
		{location: '横河镇',place: '横河',cost: '148'}, {location: '长宁镇',place: '长宁',cost: '202'}, {location: '龙华镇',place: '龙华',cost: '166'}, 
		{location: '柏塘镇',place: '柏塘',cost: '160'}, {location: '响水河镇',place: '响水河',cost: '160'}, {location: '平安镇',place: '平安',cost: '224'},
		{location: '湖镇镇',place: '湖镇',cost: '128'}, {location: '观音阁',place: '观音',cost: '208'}, {location: '杨侨镇',place: '杨侨',cost: '148'}, 
		{location: '石坝镇',place: '石坝',cost: '214'}, {location: '麻陂镇',place: '麻陂',cost: '192'}, {location: '杨村镇',place: '杨村',cost: '160'},
		{location: '泰美镇',place: '泰美',cost: '106'}, {location: '公庄镇',place: '公庄',cost: '218'},
	],
	'深圳': [{location: '深圳',place: '深圳',cost: '253'}],
	'广州': [{location: '广州',place: '广州',cost: '509'}],
}

const WEIGHT_COST = [
	{
		title: '客梯、客货梯',
		values: [
			{stations: 7,cost1: 989,cost2: 1048},
			{stations: 8,cost1: 1048},	{stations: 9,cost1: 1107},	{stations: 10,cost1: 1167},
			{stations: 11,cost1: 1226},	{stations: 12,cost1: 1285},	{stations: 13,cost1: 1345},
			{stations: 14,cost1: 1404},	{stations: 15,cost1: 1463},	{stations: 16,cost1: 1523},
			{stations: 17,cost1: 1582},	{stations: 18,cost1: 1641},	{stations: 19,cost1: 1701},
			{stations: 20,cost1: 1760},	{stations: 21,cost1: 1819},	{stations: 22,cost1: 1879},
			{stations: 23,cost1: 1938},	{stations: 24,cost1: 1997},	{stations: 25,cost1: 2057},
			{stations: 26,cost1: 2116},	{stations: 27,cost1: 2175},	{stations: 28,cost1: 2235},
			{stations: 29,cost1: 2294},	{stations: 30,cost1: 2353},	{stations: 31,cost1: 2413},
			{stations: 32,cost1: 2472},	{stations: 33,cost1: 2531},	{stations: 34,cost1: 2591},
			{stations: 35,cost1: 2650},	{stations: 36,cost1: 2709},	{stations: 37,cost1: 2769},
			{stations: 38,cost1: 2828},	{stations: 39,cost1: 2887},	{stations: 40,cost1: 2947},
		]
	},
	{
		title: '餐梯、简易电梯、杂货电梯',
		values: [
			{stations: 7,cost1: 689.5},	{stations: 8,cost1: 730},{stations: 9,cost1: 772},
			{stations: 10,cost1: 813},	{stations: 11,cost1: 854},	{stations: 12,cost1: 896},
		]
	},
	{
		title: '自动扶梯',
		values: [
			{stations: 'ZF\\ZR',cost1: 996}
		]
	},
	{
		title: '液压电梯',
		values: [
			{stations: 7,cost1: 1211.5},
			{stations: 8,cost1: 1284},
			{stations: 9,cost1: 1356},
			{stations: 10,cost1: 1429},
			{stations: 11,cost1: 1502},
			{stations: 12,cost1: 1574},
		]
	}
]

const TOTAL_HEADER_ONE = ['制造日期','检验检测','使用状态','维保单位名称','设备所在地点','设备类别','设备所在地区','下次检验日期','电梯站数','设备注册代码',
	'使用单位','出厂编号','安排日期','维保许可证超期','是否需要缴费','备注','通知确认'];


const TASK_KEY = ['维保许可证超期','是否需要缴费','备注','通知确认']

module.exports = {
	TRAVEL_COST,
	WEIGHT_COST,
	TOTAL_HEADER_ONE,
  	TASK_KEY,
  	TRAVEL_COST_NEW
}


//////////////////
// WEBPACK FOOTER
// ./static/business/businessMode.js
// module id = R6kr
// module chunks = 1